import { changeModalState } from '../../actions/modals';
import {
  savePendingPaymentSetupAction,
  PendingPaymentSetupAction
} from '../pendingPaymentSetupAction';

export const PAYMENT_METHOD_SETUP_REQUIRED_ERROR = 'PaymentMethodSetupRequiredError';

export const isPaymentMethodSetupRequiredError = (res: any): boolean =>
  res?.response?.data?.error?.name === PAYMENT_METHOD_SETUP_REQUIRED_ERROR;

/**
 * Call-site helper: if the response is a PaymentMethodSetupRequiredError,
 * dispatches the modal prompting the user to set up a new payment method for
 * off-session use and returns true. Usage in components and sagas:
 *
 *   if (handlePaymentMethodSetupRequired(res, dispatch, pendingAction)) return;
 *
 * `pendingAction` describes what the user was trying to do; it is persisted
 * across the setup redirect and automatically resumed after a successful
 * setup (see PaymentMethodSetupRequiredModal).
 */
export const handlePaymentMethodSetupRequired = (
  res: any,
  dispatch: (action: any) => void,
  pendingAction?: PendingPaymentSetupAction
): boolean => {
  if (!isPaymentMethodSetupRequiredError(res)) return false;

  if (pendingAction) savePendingPaymentSetupAction(pendingAction);
  dispatch(changeModalState({ key: 'paymentMethodSetupRequiredModal', state: true }));

  return true;
};
